import styled from 'styled-components'

const SelectCountry = styled.div`
    padding: 12px;
    border: ${(props) => props.active ? '2px solid #0080FF' : '2px solid #e4e7e7'};
    border-radius: 6px;
    margin-right: 12px;

    &:hover {
        cursor: pointer;
    }
`

export default SelectCountry
